import React from 'react';
import _ComplaintContent from './_ComplaintContent.scss';
import {Link} from 'react-router-dom';
import {Complains} from 'api';
import {LoadingPage} from 'components/loading-page';
import {ShowIf} from 'components/utils';
import {NoContent} from 'components/no-content';
import {DateTime} from 'components/UI/DateTime';

class ComplaintContent extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      data: [],
      isLoading: false,
      count: 0,
      skip: 0,
      limit: 10
    };
    this.loadMore = this.loadMore.bind(this);
  }

  componentDidMount() {
    this.setState({isLoading: true});
    Complains.actions.count.request().then((response) => {
      this.setState({count: response.data.count, isLoading: false});
      this.getList();
    }).catch((error) => {
      this.setState({isLoading: false});
    });
  }

  getList() {
    this.setState({isLoading: true});
    let params = {
      filter: {
        limit: this.state.limit,
        skip: this.state.skip
      }
    };
    Complains.actions.list.request(params).then(response => {
      let complains = this.state.data;
      response.data.map((item, idx) => {
        complains.push(item);
      });
      this.setState({data: complains, isLoading: false});
    }).catch(() => {
      this.setState({isLoading: false});
    });
  }

  loadMore() {
    this.setState({skip: this.state.skip + 10}, () => {
      this.getList();
    });
  }

  render() {
    return (
      <section className="the-news list-complaint">
        <LoadingPage isShow={this.state.isLoading} />
        <ShowIf condition={this.state.data.length > 0}>
          <table className="complaint-table">
            <thead className="complaint-table-header">
              <tr>
                <th>Loại khiếu nại</th>
                <th>Cập nhật lần cuối</th>
                <th>Nội dung</th>
              </tr>
            </thead>
            <tbody className="complaint-table-list">
              {
                this.state.data.map((item, idx) => {
                  return (
                    <tr className="complaint-item">
                      <td>Yêu cầu hỗ trợ</td>
                      <td>
                        <p><DateTime dateTime={item.updatedAt} format="HH:mm" /></p>
                        <p><DateTime dateTime={item.updatedAt} format="MM/DD/YYYY" /></p>
                      </td>
                      <td><Link to="">{item.content}</Link></td>
                    </tr>
                  );
                })
              }
              <ShowIf condition={!this.state.isLoading && this.state.data.length > 0 && (this.state.skip + this.state.limit) < this.state.count}>
                <tr>
                  <td colSpan={3} className="btn-see-more-wrap">
                    <button className="btn-see-more" onClick={this.loadMore}>Xem Thêm</button>
                  </td>
                </tr>
              </ShowIf>
            </tbody>
          </table>
        </ShowIf>
        <ShowIf condition={!this.state.isLoading && this.state.data.length == 0}>
          <NoContent content='Không có khiếu nại nào' height={600}/>
        </ShowIf>
      </section>
    );
  }
}

export default ComplaintContent;



// WEBPACK FOOTER //
// ./components/users/sub-view/complaint-content/ComplaintContent.jsx